import { ResponseGetReports } from '@vindr/services/apis/report.api';
import { ACCESS_TYPE } from '@vindr/services/apis/share.api';
import {
  PUBLIC_VIEWER_URL,
  PUBLIC_WORKSPACE_URL,
} from '@vindr/services/constants/study.constant';

export const generateShareLink = (
  study_instance_uid: string,
  accessKey: string,
  modalities: string | string[] = 'OT'
) => {
  const modality = Array.isArray(modalities) ? modalities?.[0] : modalities;

  return accessKey && study_instance_uid
    ? `${PUBLIC_VIEWER_URL}/${
        modality === 'SM' ? 'microscopy' : 'shared'
      }?StudyInstanceUIDs=${study_instance_uid}&access_key=${accessKey}`
    : '';
};

export const generateVisitLink = (params: {
  visit_id: string;
  access_key: string;
}) => {
  if (!Object.values(params).every(Boolean)) return '';

  const url = new URL(`${PUBLIC_WORKSPACE_URL}/visit-study`);
  Object.entries(params).forEach(([key, value]) =>
    url.searchParams.append(key, value)
  );

  return url.toString();
};

export function getAccessKeys(
  share_access_keys: ResponseGetReports['data'][number]['share_access_keys']
) {
  return (
    Array.isArray(share_access_keys) &&
    share_access_keys.reduce(
      (prev, curr) => {
        if (curr.type === ACCESS_TYPE.Study) prev.study_access_key = curr;
        if (curr.type === ACCESS_TYPE['Visit ID']) prev.visit_access_key = curr;
        return prev;
      },
      {} as {
        study_access_key: ResponseGetReports['data'][number]['share_access_keys'][number];
        visit_access_key: ResponseGetReports['data'][number]['share_access_keys'][number];
      }
    )
  );
}
